/**
 * @flow
 * @relayHash 477b1d6ba0d86e96b767ca047521d0dc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConnectWithOrganizationInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type ConnectWithOrganizationMutationVariables = {|
  input: ConnectWithOrganizationInput
|};
export type ConnectWithOrganizationMutationResponse = {|
  +connectWithOrganization: ?{|
    +success: ?boolean,
    +organization: ?{|
      +status: ?string
    |},
  |}
|};
export type ConnectWithOrganizationMutation = {|
  variables: ConnectWithOrganizationMutationVariables,
  response: ConnectWithOrganizationMutationResponse,
|};
*/


/*
mutation ConnectWithOrganizationMutation(
  $input: ConnectWithOrganizationInput!
) {
  connectWithOrganization(input: $input) {
    success
    organization {
      status
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConnectWithOrganizationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "success",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ConnectWithOrganizationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "connectWithOrganization",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ConnectWithOrganizationPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "organization",
            "storageKey": null,
            "args": null,
            "concreteType": "OrgNode",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ConnectWithOrganizationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "connectWithOrganization",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ConnectWithOrganizationPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "organization",
            "storageKey": null,
            "args": null,
            "concreteType": "OrgNode",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ConnectWithOrganizationMutation",
    "id": null,
    "text": "mutation ConnectWithOrganizationMutation(\n  $input: ConnectWithOrganizationInput!\n) {\n  connectWithOrganization(input: $input) {\n    success\n    organization {\n      status\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f71a93e827676369f3822183e2c4b74a';
module.exports = node;
